import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { EntityPageMode, getEntityPathTemplate } from "navigation";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const DriverProfileListPage = lazy(() => import("./DriverProfileListPage"));
const DriverProfilePage = lazy(() => import("./DriverProfilePage"));

export const driverProfileRoutes: RouteDescription[] = [
  {
    path: links.driverProfile,
    element: withPageLoader(<DriverProfileListPage />),
    breadcrumb: "Drivers",
    menuItem: {
      id: "drivers",
      label: "Drivers",
    },
    requiredOneOfPermissions: [
      Permissions.AffiliateManager,
      Permissions.Admin,
      Permissions.SuperAdmin,
      Permissions.Compliance,
    ],
  },
  {
    path: getEntityPathTemplate(links.driverProfile),
    element: withPageLoader(<DriverProfilePage />),
    breadcrumb: "Driver profile",
    pageModePermissions: {
      [EntityPageMode.view]: {
        requiredOneOfPermissions: [
          Permissions.AffiliateManager,
          Permissions.Admin,
          Permissions.SuperAdmin,
          Permissions.Compliance,
        ],
      },
      [EntityPageMode.edit]: {
        requiredOneOfPermissions: [
          Permissions.Admin,
          Permissions.SuperAdmin,
          Permissions.Compliance,
        ],
      },
    },
  },
];

